import React from "react"
import { Navigate, Route, Routes } from "react-router-dom"
import { ShutdownScreen } from "../screens/ShutdownScreen"

export enum RoutePaths {
	Home = "/",
	Marketplace = "/marketplace",
	Activity = "/activity",
	AssetResource = "/asset/:collectionAddress/:collectionName/:resource/:nftId",
	Asset = "/asset/:collectionAddress/:collectionName/:nftId",
	UserFlow = "/user/:walletAddress",
	UserSignIn = "/signIn",
	UserProfileScreen = "/user-profile",
	UserProfileScreenP2P = "/user-profile/loans",
	UserProfileScreenRentals = "/user-profile/rentals",
	UserProfileScreenStorefront = "/user-profile/storefront",
	Settings = "/settings",
	SettingsNotifications = "/notification-settings",
	Listed = "/listed",
	Loans = "/loans",
	Funded = "/funded",
	LoanListing = "/listing/:listingResourceId",
	Terms = "/tos",
	Privacy = "/privacy",
	RentalListing = "/rentals/:listingResourceId",
	RentalMarketplace = "/rentals",
	ProfileFlowScreen = "/user/profile",
	ProfileCreatorHubFlowScreen = "/user/creator-hub",
	SwapListing = "/swaps/:listingResourceId",
	Collection = "/collection/:collectionAddress/:collectionName",
	Storefront = "/storefront",
	StorefrontListing = "/storefront/:listingResourceId",
	Collections = "/collections",
	TwitterOauth = "/_twitter-oauth",
	DiscordOauth = "/_discord-oauth",
	CreatorHub = "/create",
}

export const composeUserProfilePath = (userWalletAddress: string): string =>
	RoutePaths.UserFlow.replace(":walletAddress", userWalletAddress)

const composeListingResourcePath = (
	basePath: `${string}/:listingResourceId`,
	listingResourceId: string | number
): string => basePath.replace(":listingResourceId", String(listingResourceId))

export const composeLoanListingPath = (listingID: string | number): string =>
	composeListingResourcePath(RoutePaths.LoanListing, listingID)

export const composeRentalListingPath = (listingID: string | number): string =>
	composeListingResourcePath(RoutePaths.RentalListing, listingID)

// Flowty has ceased operations: the home page is the only screen, and every
// other path redirects to it.
export const RenderRoutes: React.FunctionComponent = () => (
	<Routes>
		<Route path={RoutePaths.Home} element={<ShutdownScreen />} />
		<Route path='*' element={<Navigate replace to={RoutePaths.Home} />} />
	</Routes>
)
